import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

// Hub de Prospecção: rota-pai com header + abas, e as três telas existentes
// como filhas. Os nomes de rota (`lead_prospector_index`, `prospecting_lists_index`,
// `prospecting_dashboard`) são preservados para não quebrar o menu nem links existentes.
const ProspectingHub = () => import('./ProspectingHub.vue');
const LeadProspectorPage = () =>
  import('../lead-prospector/LeadProspectorPage.vue');
const MyProspectingLists = () =>
  import('../lead-prospector/MyProspectingLists.vue');
const ProspectingListDetail = () =>
  import('../lead-prospector/ProspectingListDetail.vue');
const Prospecting = () => import('../prospecting/Prospecting.vue');
const DocumentLookup = () => import('../lead-prospector/DocumentLookup.vue');
const GroupRadarLeads = () => import('./GroupRadarLeads.vue');
const InstagramProspects = () => import('./InstagramProspects.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.COMPANIES,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/prospeccao'),
    component: ProspectingHub,
    meta: {
      ...commonMeta,
      permissions: ['administrator', 'agent', 'prospecting_manage'],
    },
    children: [
      {
        path: '',
        redirect: to => ({
          name: 'lead_prospector_index',
          params: to.params,
        }),
      },
      {
        path: 'buscar',
        name: 'lead_prospector_index',
        component: LeadProspectorPage,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'agent', 'prospecting_manage'],
        },
      },
      {
        path: 'minhas-prospeccoes',
        name: 'prospecting_lists_index',
        component: MyProspectingLists,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'agent', 'prospecting_manage'],
        },
      },
      {
        path: 'minhas-prospeccoes/:listId',
        name: 'prospecting_lists_show',
        component: ProspectingListDetail,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'agent', 'prospecting_manage'],
        },
      },
      {
        path: 'consulta-documento',
        name: 'document_lookup_index',
        component: DocumentLookup,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'agent', 'prospecting_manage'],
        },
      },
      {
        path: 'instagram',
        name: 'instagram_prospects_index',
        component: InstagramProspects,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'agent', 'prospecting_manage'],
        },
      },
      {
        path: 'campanhas',
        name: 'prospecting_dashboard',
        component: Prospecting,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'prospecting_manage'],
        },
      },
      {
        path: 'radar-grupos',
        name: 'group_radar_leads_index',
        component: GroupRadarLeads,
        meta: {
          ...commonMeta,
          permissions: ['administrator', 'prospecting_manage'],
        },
      },
    ],
  },
];
